<div class="p-grid p-col-12 content-services">
  <div class="p-col-12 p-md-offset-8 p-md-4 p-lg-offset-7 p-lg-5 p-justify-end">
    <div class="p-grid">
      <div class="p-col-12 p-col-align-end p-md-6 p-lg-6">
        <p-button
          class="p-col-12"
          [style]="{ 'text-align': 'center', 'justify-content': 'flex-end' }"
          label="Programar Servicios "
          (onClick)="showServiceCreation()"
        ></p-button>
      </div>
      <div class="p-col-12 p-col-align-end p-md-6 p-lg-6">
        <p-button class="p-col-12" [style]="{ 'text-align': 'center' }" label="Exportar Rutas" (click)="exportExcel()"></p-button>
      </div>
    </div>
  </div>
  <div class="p-col-12 p-md-6 p-lg-6">
    <p-card *ngFor="let vehicle of vehicles" (click)="refreshVehicleServices(vehicle)">
      <div
        [ngClass]="vehicle.vehicleId === itemVehicleSelected ? 'content-item-block selected' : 'content-item-block'"
        [style.backgroundColor]="vehicle.vehicleId === itemVehicleSelected ? '#2ab1be' : '#ffffff'"
      >
        <p-header>
          <h1 style="padding: 13px">Vehículo: {{ vehicle.vehicleId }}</h1>
        </p-header>
        <ol>
          <li><strong>Capacidad Utilizada:</strong> {{ vehicle.capacity }} / {{ vehicle.usedCapacity }}</li>
          <li><strong>Status :</strong> {{ vehicle.apiServiceMessage }}</li>
          <li><strong>Service UUID :</strong> {{ vehicle.apiServiceId }}</li>
        </ol>
      </div>
      <div
        class="p-col-12 p-md-offset-9 p-md-3 p-lg-offset-9 p-lg-3"
        *ngIf="vehicle.vehicleId === itemVehicleSelected && !vehicle.apiServiceId"
      >
        <p-button class="btn-sel-edit-point" label="Editar Ruta" (onClick)="showEditPoint()"></p-button>
      </div>
    </p-card>
    <div *ngIf="stateExtras" class="p-col-8">
      <p-button class="btn-sel-edit-point" label="REGRESAR" (onClick)="goBack()"></p-button>
    </div>
  </div>
  <div class="p-col-12 p-md-6 p-lg-6">
    <!-- <p-gmap
      [options]="options"
      [overlays]="overlays"
      (onMapReady)="setMap($event)"
      [style]="{ width: '100%', height: '600px' }"
      *ngIf="showMapRoute"
    ></p-gmap> -->
    <div class="content_loading-service" *ngIf="!showMapRoute">
      <img src="../../../../../../../assets/layout/images/loading.gif" alt="loading" />
    </div>
  </div>
  <p-dialog header="Programación Servicios " modal="true" [(visible)]="serviceProgramVisible" class="mu-no-shadow-dialog">
    <app-mu-form-fieldset label="massive.userIdLabel">
      <input type="text " pInputText [(ngModel)]="userId" />
    </app-mu-form-fieldset>
    <p-footer>
      <p-button label="Crear Servicios " (onClick)="programDelivery()"></p-button>
    </p-footer>
  </p-dialog>
  <div class="content-validate-loading p-col-12" *ngIf="mdloadingerrormasivo">
    <div class="p-grid">
      <div class="content-block p-col-12 p-md-offset-3 p-md-6 p-lg-offset-3 p-lg-6 p-align-center">
        <div class="content_bg">
          <div class="content_loading">
            <p>Consultando Data</p>
            <p *ngIf="!mdloadingerrorMasivoMsn">Este proceso puede tardar varios minutos…</p>
            <img *ngIf="!mdloadingerrorMasivoMsn" src="../../../../../../../assets/layout/images/loading.gif" alt="loading" />
          </div>
          <div class="content_loading" *ngIf="mdloadingerrorMasivoMsn">
            <div class="content_btn_state">
              <h4>Servicio No Enrutado</h4>
            </div>
            <div class="content-validate-final-btn">
              <div class="content_loading">
                <div class="p-grid">
                  <div class="p-col-12 p-col-align-end p-md-12 p-lg-12">
                    <p-button
                      class="p-col-12 btn-step"
                      [style]="{ 'text-align': 'center' }"
                      label="Aceptar"
                      (click)="returnTwoStep()"
                    ></p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content-validate-final p-col-12" *ngIf="mdloadingmasivo">
    <div class="p-grid p-align-center p-col-align-stretch">
      <div class="content-block p-col-12 p-md-offset-1 p-md-10 p-lg-offset-3 p-lg-6 p-align-center">
        <div class="content_bg">
          <div class="content_description">
            <div class="p-grid p-align-center">
              <div class="content-block-img p-col-12 p-md-offset-3 p-md-6 p-lg-offset-3 p-lg-6 p-align-center">
                <div class="block-content-ico">
                  <div class="block-icon">
                    <img src="../../../../../../../assets/layout/images/icon-calendar.png" alt="icon-calendar" />
                  </div>
                  <div class="block-check">
                    <img src="../../../../../../../assets//layout/images/icon-state-ok.png" alt="icon-state-ok" />
                  </div>
                </div>
              </div>
            </div>
            <div class="block-content-title">
              <h3>Masivo programado</h3>
            </div>
            <div class="block-content-txt">
              <p>Empezaremos la convocatoria de mensajeros para tus entregas.</p>
              <p>Puedes cancelar el envío o reprogramarlo en la sección Servicios…</p>
            </div>
          </div>
          <div class="content_loading" *ngIf="reponseStateMassivo === '' && reponseMsgMassivo === ''">
            <img src="../../../../../../../assets/layout/images/loading.gif" alt="loading" />
          </div>
          <div class="content_loading" *ngIf="reponseStateMassivo !== '' && reponseMsgMassivo !== ''">
            <div class="p-grid">
              <div class="p-col-12 p-col-align-end p-md-6 p-lg-6">
                <p-button
                  class="p-col-12 btn-step"
                  [style]="{ 'text-align': 'center' }"
                  label="Descargar Resumen"
                  (click)="exportExcel()"
                ></p-button>
              </div>
              <div class="p-col-12 p-col-align-end p-md-6 p-lg-6">
                <p-button
                  class="p-col-12 btn-step"
                  [style]="{ 'text-align': 'center' }"
                  label="Aceptar"
                  (click)="returnInitialStep()"
                ></p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="block-modal-edit-point">
    <p-dialog header="{{ titleHeader }}" modal="true" [(visible)]="editNumberPoint" (onHide)="hideEditPoint()">
      <div class="content-edit-points">
        <div class="ui-g p-grid">
          <div class="p-col-6 p-md-6 p-lg-6 content-edit-points-map">
            <!-- <p-gmap
              [options]="options"
              [overlays]="overlaysEdit"
              (onMapReady)="setMapEdit($event)"
              [style]="{ width: '100%', height: '600px' }"
              *ngIf="showMapRouteEdit"
            ></p-gmap> -->
            <div class="content_loading-service" *ngIf="!showMapRouteEdit">
              <img src="../../../../../../../assets/layout/images/loading.gif" alt="loading" />
            </div>
          </div>
          <div class="p-col-6 p-md-6 p-lg-6 content-edit-points-list">
            <p-orderList [value]="routedEditServices" class="block-item-in-route" (onReorder)="onReorder($event)">
              <ng-template let-service pTemplate="item ">
                <p-card (click)="zoomToEdit(service)">
                  <div class="id-rute-color">
                    <div class="edit-input-point" *ngIf="service.edit">
                      <input
                        type="number"
                        min="1"
                        max="{{ routedEditServices.length }}"
                        value="{service.order}"
                        [(ngModel)]="service.order"
                      />
                      <p-button class="btn-edit-point" label="Actualizar" (onClick)="updatePoints(service)"></p-button>
                    </div>
                    <strong *ngIf="!service.edit">{{ service.order }}</strong>
                  </div>
                  <div class="cont-rute-color">
                    <p-header>
                      {{ service.clientName }}
                    </p-header>
                    <strong>Dirección :</strong> {{ service.address }}
                    <p><strong>Teléfono :</strong> {{ service.phone }}</p>
                  </div>
                </p-card>
              </ng-template>
            </p-orderList>
          </div>
        </div>
      </div>
      <p-footer>
        <div class="p-grid">
          <div class="p-col-12 p-md-offset-8 p-md-4 p-lg-offset-8 p-lg-4 block-cont-footer">
            <div class="p-grid">
              <div class="p-col-12 p-md-6 p-lg-6 block-btn-content">
                <button type="button" pButton icon="pi pi-check" (click)="saveDataRoute()" label="Guardar Ruta"></button>
              </div>
              <div class="p-col-12 p-md-6 p-lg-6 block-btn-content">
                <button
                  type="button"
                  pButton
                  icon="pi pi-times"
                  (click)="hideEditPoint()"
                  label="Cancelar"
                  class="ui-button-secondary"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </p-footer>
    </p-dialog>
  </div>
  <div class="ui-g" *ngIf="showLoadingUpdateData">
    <app-loading [title]="'Guardando direcciones'" [description]="'Este proceso puede tardar varios minutos…'"> </app-loading>
  </div>
</div>
